// Lib
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import {
    ScreenOrientation,
    OrientationType as CapacitorOrientationType,
} from '@capawesome/capacitor-screen-orientation';
import { CAPACITOR_SCREEN_ORIENTATION_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { getPlatformDetailsSelector } from '../platformSelector';
import { isPlatformNativeMobileApp } from '../utils/platformDetailsUtils';

let lockCount = 0;

/**
 * Locks the screen orientation to portrait mode when `lockScreenOrientation` is true.
 */
export default function useLockScreenOrientationPortrait(lockScreenOrientation: boolean) {
    const platformDetails = useSelector(getPlatformDetailsSelector);

    // Lock the screen orientation to portrait mode when lockScreenOrientation is true
    useEffect(() => {
        // The lock and unlock methods are not available on the web
        if (!isPlatformNativeMobileApp(platformDetails)) return;

        if (!Capacitor.isPluginAvailable(CAPACITOR_SCREEN_ORIENTATION_PLUGIN)) return;

        if (!lockScreenOrientation) return;

        lockCount++;

        // NOTE: These are promise based, but we don't need to await them
        ScreenOrientation.lock({ type: CapacitorOrientationType.PORTRAIT });

        return () => {
            lockCount--;
            if (lockCount > 0) return;

            ScreenOrientation.unlock();
        };
    }, [lockScreenOrientation]);
}
